import { useContext } from 'react'
import { AuthContext } from "../../context/AuthContext";
import {
  Box,
  Flex,
  IconButton,
  HStack,
  Circle, Menu, MenuButton, MenuList, MenuItem,
  useToast,
  useDisclosure
} from '@chakra-ui/react';
import { FaUser, FaBullhorn, FaCar, FaMapMarkerAlt, FaRegBell } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import UserService from '../../services/UserService';
import CommonService from '../../services/CommonService';
import { getPassengerRideDataFromStorage } from '../../utils/localStorage';
import { useDispatch } from 'react-redux';
import { setCancelRideData } from '../../store/features/cancelRideSlice';
import ConfirmationModal from '../ConfirmationModal';

const Footer = () => {

  const user = JSON.parse(localStorage.getItem("user"));
  const rideSession = getPassengerRideDataFromStorage();
  const toast = useToast();
  const dispatch = useDispatch();
  const {
    isOpen: isCancelOpen,
    onOpen: onCancelOpen,
    onClose: onCancelClose,
  } = useDisclosure();

  const navigate = useNavigate();
  const { logout } = useContext(AuthContext);

  const goTo = (page) => {
    navigate(page)
  }

  const cancelRide = async () => {

    let params = {
      uId: user.uId,
      ReqNo: rideSession.ReqNo
    };
    if (rideSession.ReqNo > 0) {
      try {
        const res = await UserService.passengerCancelToRide(params)
        if (res.statusCode === 200) {
          console.log("dispatch sucess")
          dispatch(setCancelRideData("cancel-by-passenger"))
          toast({
            title: 'Cancel Ride',
            description: res.message,
            status: 'success',
            duration: 3000,
            isClosable: true,
            position: 'top-right',
          });
        }
      } catch (error) {
        if (error.response?.status === 401) {
          toast({
            title: 'Error',
            description: error.response.data.message,
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top-right',
          });
        } else {
          toast({
            title: 'Error',
            description: "Something went wrong. Please try again.",
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top-right',
          });
          console.error(error);
        }
      }
    } else {
      haveNotBookedRide()
    }
  }
  const handleCancelConfirm = async () => {
    await cancelRide();
    onCancelClose();
  };

  const handleCancelRideClick = () => {
    const rideSessionData = getPassengerRideDataFromStorage()
    if (rideSessionData.ReqNo > 0) {
      onCancelOpen(); // show confirmation popup
    } else {
      haveNotBookedRide(); // show toast
    }
  }

  const haveNotBookedRide = () => {
    toast({
      title: 'Ride',
      description: 'I have not booked any ride',
      status: 'error',
      duration: 3000,
      isClosable: true,
      position: 'top-right',
    });
  };

  const handleAlarm = async () => {
    let params = {
      uId: user.uId,
      CompCd: user.CompCd,
      authToken: user.authToken,
      role: user.role
    }
    try {
      const res = await CommonService.sendAlarm(params);
      if (res.statusCode === 200) {
        toast({
          title: 'Ride',
          description: res.message,
          status: 'success',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      }
    } catch (error) {
      toast({
        title: 'Error',
        description: error,
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      });
    }
  }

  return (
    <Box position="fixed" bottom="0" left="0" right="0" bg="gray.300" height="50px" zIndex={10}>
      <Flex justify="center" align="center" height="100%" position="relative">
        <HStack spacing={4}>
          <Menu>
            <MenuButton
              as={IconButton}
              icon={<FaUser />}
              aria-label="Profile Menu"
              borderRadius="full"
            />
            <MenuList>
              <MenuItem onClick={() => goTo("/user/transactions")}>History</MenuItem>
              <MenuItem onClick={() => goTo("/user/payment")}>Subscribe</MenuItem>
              <MenuItem onClick={() => goTo("/user/profile")}>Profile</MenuItem>
              <MenuItem onClick={() => goTo("/user/emergency-contact")}>Emergency Contact</MenuItem>
              <MenuItem onClick={() => goTo("/user/change-password")}>Change Password</MenuItem>
              <MenuItem onClick={logout}>
                Logout
              </MenuItem>
            </MenuList>
          </Menu>

          <IconButton
            icon={<FaMapMarkerAlt />}
            aria-label="Map"
            borderRadius="full"
            onClick={() => goTo("/user/map")}
          />

          {/* Center Button */}
          <Box position="relative" top="-15px">
            <Circle
              size="70px"
              bg="red.500"
              color="white"
              border="4px solid pink"
              onClick={handleAlarm}
              cursor="pointer" // optional: to show pointer on hover
              _hover={{ opacity: 0.8 }} // optional: visual feedback
            >
              <FaBullhorn size={25} />
            </Circle>
          </Box>

          <Menu>
            <MenuButton
              as={IconButton}
              icon={<FaCar />}
              aria-label="Driver Menu"
              borderRadius="full"
            />
            <MenuList>
              <MenuItem onClick={handleCancelRideClick}>Cancel Ride</MenuItem>
              <MenuItem onClick={() => goTo("/user/tips")}>Tips</MenuItem>
            </MenuList>
          </Menu>

          <IconButton icon={<FaRegBell />} aria-label="Nofications" borderRadius="full" />
        </HStack>
      </Flex>
      <ConfirmationModal
        isOpen={isCancelOpen}
        onClose={onCancelClose}
        onConfirm={handleCancelConfirm}
        title="Cancel Ride"
        message="Are you sure you want to cancel this ride?"
      />
    </Box>
  )
}

export default Footer
